import { render, staticRenderFns } from "./TemplateDrawer.vue?vue&type=template&id=3460fece&scoped=true"
import script from "./TemplateDrawer.vue?vue&type=script&lang=js"
export * from "./TemplateDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3460fece",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3460fece')) {
      api.createRecord('3460fece', component.options)
    } else {
      api.reload('3460fece', component.options)
    }
    module.hot.accept("./TemplateDrawer.vue?vue&type=template&id=3460fece&scoped=true", function () {
      api.rerender('3460fece', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/templates/designer/TemplateDrawer.vue"
export default component.exports